const filterClickEventDataTransformer = (eventValue, filterName, filtersValues, statFilterValue) => {
  let scrubbedEventValue = eventValue.includes('|') ? eventValue.split('|')[1] : eventValue;
  let search = {};
  let eventResult = null;
  switch (filterName) {
    case 'maxPrice':
      search = {
        priceMin: filtersValues?.minPrice || `${statFilterValue?.derivedprice?.min}`,
        priceMax: eventValue
      };
      scrubbedEventValue = `min|${eventValue}`;
      break;
    case 'minPrice':
      search = {
        priceMin: eventValue,
        priceMax: filtersValues?.maxPrice || `${statFilterValue?.derivedprice?.max}`
      };
      scrubbedEventValue = `${eventValue}|max`;
      break;
    case 'startYear':
      search = {
        yearMin: eventValue,
        yearMax: filtersValues?.endYear || `${statFilterValue?.year?.max}`
      };
      scrubbedEventValue = `${eventValue}|max`;
      break;
    case 'endYear':
      search = {
        yearMin: filtersValues?.startYear || `${statFilterValue?.year?.min}`,
        yearMax: eventValue
      };
      scrubbedEventValue = `min|${eventValue}`;
      break;
    case 'zip':
      search.zipCode = eventValue;
      eventResult = `zip::${eventValue}`;
      break;
    default:
      break;
  }
  return {
    scrubbedEventValue,
    search,
    eventResult
  };
};
export default filterClickEventDataTransformer;